import { hasFieldError } from '@presentation/utils';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useField } from 'formik';
import type { FC } from 'react';
import { FaTimes } from 'react-icons/fa';
import { ErrorText, InputDate } from '..';
import type { InputDateFieldProps } from './types';

export * from './types';

export const InputDateField: FC<InputDateFieldProps> = (props) => {
  const {
    name,
    clearable = false,
    disableFutureDates = false,
    disablePastDates = false,
    ...rest
  } = props;
  const [field, meta, helpers] = useField<Dayjs>(name);

  return (
    <>
      <InputDate
        hasError={hasFieldError(meta)}
        iconRight={
          clearable &&
          field.value !== meta.initialValue && (
            <FaTimes
              onClick={() => meta.initialValue && helpers.setValue(meta.initialValue ?? undefined)}
            />
          )
        }
        name={name}
        onBlur={field.onBlur}
        value={
          !field.value
            ? ''
            : dayjs(field.value).format(
                rest.calendarProps?.maxDetail === 'year' ? 'MM/YYYY' : 'DD/MM/YYYY',
              )
        }
        {...rest}
        calendarProps={{
          ...rest.calendarProps,
          value: field.value ? dayjs(field.value).toDate() : undefined,
          onChange: (value: Date) => {
            helpers.setValue(dayjs(value));
          },
          ...(disableFutureDates
            ? {
                tileDisabled: ({ date }) => {
                  return date.getTime() > +dayjs();
                },
              }
            : {}),
          ...(disablePastDates
            ? {
                tileDisabled: ({ date }) => {
                  return date.getTime() < +dayjs();
                },
              }
            : {}),
        }}
      />
      {hasFieldError(meta) && <ErrorText>{meta.error}</ErrorText>}
    </>
  );
};
